import { render } from "./position_user.vue?vue&type=template&id=4873bbdf"
import script from "./position_user.vue?vue&type=script&lang=js"
export * from "./position_user.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/reduction/comerc/position/position_user.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4873bbdf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4873bbdf', __exports__)) {
    console.log('reload')
    api.reload('4873bbdf', __exports__)
  }
  
  module.hot.accept("./position_user.vue?vue&type=template&id=4873bbdf", () => {
    console.log('re-render')
    api.rerender('4873bbdf', render)
  })

}


export default __exports__